import { useEffect, useState, useCallback } from "react";
import { Box, Button,PaginationItem, Pagination,  Container, Typography, Dialog, DialogTitle, DialogContent, DialogActions, useMediaQuery, TextField, MenuItem,} from "@mui/material";
import { DataGrid, useGridApiRef, gridPageCountSelector, gridPageSelector, useGridSelector,  } from "@mui/x-data-grid";
import { Style } from "@mui/icons-material";
import { callPostApi } from "../../../components/API/ApiCallFunction";
import GradientLoader from "../../CommanComponents/GradientLoader";
import ReusableDialog from "../../CommanComponents/ReusableDialog";
import { useNavigate } from "react-router-dom";
import FullImgPreview from "../../CommanComponents/FullImgPreview";
function CustomPagination({ apiRef, isMobile }) {
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  const handlePageChange = (_, value) => {
    apiRef.current.setPage(value - 1);

    if (isMobile && apiRef.current) {
      setTimeout(() => {
        apiRef.current.autosizeColumns({ includeHeaders: true });
      }, 0);
    }
  }; return (
    <Pagination color="primary" variant="outlined" shape="rounded"
      page={page + 1}
      count={pageCount}
      renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
      onChange={handlePageChange}
    />
  );
}

export function IssuedList() {
  const apiRef = useGridApiRef();
  const isMobile = useMediaQuery("(max-width:768px)");
  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [filterLimit, setFilterLimit] = useState(100);
  const [open, setOpen] = useState(false);
  const [openD, setOpenD] = useState(false);
  const [loading, setLoading] = useState(false);
  const [datar, setDatar] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [paginationModel, setPaginationModel] = useState({ pageSize: 10, page: 0,});
  const handleClose = () => setOpen(false);
  const decodeHTML = (html) => { 
    const txt = document.createElement("textarea"); 
    txt.innerHTML = html;
    return txt.value;
  };

 
  // Issue List API 
  const issueListApi = useCallback(async () => {
    try {
      setLoading(true);
      const storeid = user.store_info?.store_id;
      const payload = { mod: "CASHI_ISSUE_COUPON", data_arr: { store_id: storeid, start: 0, limit: filterLimit,},};
      const apiResult = await callPostApi("cashi-customer", payload);

      if (apiResult.status === "200" && Array.isArray(apiResult.data)) {
        const formattedData = apiResult.data.map((item, index) => ({
          id: index+1,
          coupon_id: item.coupon_id || "NA",
          ctitle: item.offer_title || "NA",
          date: item.coupon_active || "NA",
          expdate: item.coupon_expire || "NA",
          coupon_code: item.coupon_code || "NA",
          coupon_coin: item.coupon_coin || "NA",
          short_desc: item.short_desc || "NA",
          long_desc: item.long_desc || "NA",
          offerlogo: item.offer_logo || "",
          customerName: item.cust_name || "NA",
          customerMobile: item.cust_mobile || "",
        }));
        setDatar(formattedData);
      } else { setDatar([]);}
    } finally { setLoading(false);}
  }, [user.store_info?.store_id, filterLimit]);

  useEffect(() => {
    issueListApi(paginationModel.page, paginationModel.pageSize);
  }, [paginationModel.page, paginationModel.pageSize,issueListApi]);

   const columns = [
    { field: "id", headerName: "Sr No.", flex: 0.5 },
    { field: "offerlogo", headerName: "Coupon Image", flex: 1,
     renderCell: (params) => { if (!params.value || params.value === "NA") { return <Typography variant="body2">No Image</Typography>; }
              return <FullImgPreview src={params.value} />;  }, },
    { field: "customerName", headerName: "Customer Name", flex: 1.5 },
    { field: "customerMobile", headerName: "Mobile", flex: 1.5,
      renderCell: (params) => { const mobile = params.value || ''; const visiblePart = mobile.slice(0, 2);
      const hiddenPart = '*'.repeat(8); return `${visiblePart}${hiddenPart}`; } },
    { field: "ctitle", headerName: "Coupon Title", flex: 1.5 },
    { field: "date", headerName: "Issued Date", flex: 1 },
    { field: "expdate", headerName: "Expiry Date", flex: 1 },
  ];


  return (
    <Container sx={{ my: 2 }}>
  
      <Box sx={{ display: "flex", justifyContent: "start", mb: 2 }}>
        <Button  variant="contained"  sx={{ backgroundColor: "#000000", color: "#ffffff" }} onClick={() => navigate(-1)}>
          Back
        </Button>
      </Box>

      {/* Title */}
      <Typography ariant="h6"  gutterBottom sx={{ background: "linear-gradient(195deg, #49a3f1, #1A73E8)",  p: 1, color: "#ffffff",
          borderRadius: "4px", mb: 3, display: "flex", alignItems: "center",}}><Style sx={{ mr: 1 }} /> Issued Coupons
      </Typography>

 
     {/* Toolbar */}
     <Box sx={{my:2}}>
       <TextField  select label="Limit" value={filterLimit} onChange={(e) => { setFilterLimit(e.target.value);}} sx={{ minWidth: 140, }}>
           <MenuItem value={100}>100</MenuItem>
           <MenuItem value={300}>300</MenuItem>
           <MenuItem value={500}>500</MenuItem>
           <MenuItem value={2000}>All</MenuItem>
        </TextField>
        <Button  variant="outlined" color="primary"  sx={{ height: 56 , mx:1}} onClick={() => { issueListApi();}}>
         Apply Filter
        </Button>
     </Box>

      {/* DataGrid */}
      <Box sx={{ height: "auto", width: "100%", mb: 4 }}>
        <DataGrid apiRef={apiRef} rows={datar} columns={columns} showToolbar  disableRowSelectionOnClick getRowHeight={() => "auto"}
         onPaginationModelChange={setPaginationModel} paginationModel={paginationModel}   
         slots={{ pagination: () => <CustomPagination apiRef={apiRef} isMobile={isMobile} />,}}

          sx={{
            "& .MuiDataGrid-cell": {
              whiteSpace: "normal",
              wordBreak: "break-word",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#f0f0f0",
              color: "#000",
              fontWeight: "bold",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontSize: 14,
              fontWeight: 600,
              whiteSpace: "normal",
              wordBreak: "break-word",
            },
          }}
        />
      </Box>

      {/* Campaign Dialog */}
      <ReusableDialog open={open} onClose={handleClose} />

      {/* Detail Dialog */}
      <Dialog  open={openD} onClose={() => setOpenD(false)} maxWidth="sm"  fullWidth sx={{ overflowY: "auto" }}>
        <Box>
          {selectedRow ? (
            <>
              <DialogTitle sx={{ background: "linear-gradient(195deg, #49a3f1, #1A73E8)", color: "#fff", }}>
                <Typography variant="h6"> Coupon Code: {selectedRow.coupon_code} </Typography>
              </DialogTitle>
              <DialogContent>
                <Typography sx={{ my: 1 }}> Coupon Coin: {selectedRow.coupon_coin} </Typography>
                <Typography sx={{ mb: 2 }}> Validity: {selectedRow.expdate} </Typography>

                <Box sx={{ p: 2 }}>
                  <Typography variant="subtitle1" gutterBottom> Short Description </Typography>
                  <Box sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2, background: "#fafafa",}}
                    dangerouslySetInnerHTML={{  __html: decodeHTML(selectedRow.short_desc),}}
                  />
                  <Typography variant="subtitle1" sx={{ mt: 2 }} gutterBottom> Long Description </Typography>
                  <Box sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2, background: "#fafafa", }}
                    dangerouslySetInnerHTML={{  __html: decodeHTML(selectedRow.long_desc),}}/>
                </Box>
              </DialogContent>
              <DialogActions> <Button onClick={() => setOpenD(false)} variant="contained"> Close </Button></DialogActions>
            </>
          ) : (
            <Typography>No details available</Typography>
          )}
        </Box>
      </Dialog>

      {loading && <GradientLoader text="Loading" />}       { /* Loader */}
    </Container>
  );
}
